import { Injectable } from '@angular/core';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root',
})
export class WishApiService {
  constructor(private http: HttpService) {}

  buildurl(path: string, queryMap: any = null): string {
    return this.http.buildurl('/wish' + path, queryMap);
  }

  createWish(platformName: string) {
    const url = this.buildurl('');
    return this.http.post(url, { platform_name: platformName });
  }

  findWishProducts(page = 1, pageSize = 10) {
    const url = this.buildurl('/products', { page, page_size: pageSize });
    return this.http.fget(url);
  }
}
